import { useState } from "react";
import { taskService } from "@miplatform/api";
import { ATTEMPT_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { createUUID } from "@miplatform/utils";

const GET_DISPATCH_VERIFICATION_ATTEMPTS_UUID = createUUID();

export const useDispatchVerificationReviewViewModel = () => {
  const [attempts, setAttempts] = useState([]);
  const stateManager = useComponentState();

  const getAttempts = ({
    top = 25,
    skip,
    sort = "scheduledStartDate asc",
    filters = {},
    params,
    signal,
  } = {}) => {
    stateManager.abort(GET_DISPATCH_VERIFICATION_ATTEMPTS_UUID);

    return stateManager.run(
      () =>
        taskService.attempts.getAll({
          top,
          skip,
          sort,
          params,
          signal,
          filters: {
            ...filters,
            pendingVerification: true,

            attemptStatus: {
              in: [
                ATTEMPT_STATUSES.CLOSEOUT_IN_PROGRESS,
                ATTEMPT_STATUSES.SUBMITTED,
              ],
            },
          },
        }),
      GET_DISPATCH_VERIFICATION_ATTEMPTS_UUID
    );
  };

  return {
    attempts,
    getAttempts,
    isLoading: stateManager.isBusy(),
    setAttempts,
  };
};
